module.exports = __webpack_public_path__ + "static/logo-971986a4edfdd2c729658e590eff8456.svg";